export default __webpack_public_path__ + "static/media/icon-fleet.164faa26.svg";